<template>
  <div class="guide">
    <div v-show="gospa" class="box ru50 flex alcen jucen cursor" @click="gomd"><i class="el-icon-bottom co6e sz20 font_bo`"></i></div>
    <div class="top flex alcen" id="box1">
      <div class="top_list sz40 font_bo">
        <div class="w100 center">一键打开海外营销分销渠道</div>
        <div class="w100 center co6e">全面洞悉行业标杆+品牌情报</div>
      </div>
      <div class="top_list">
        <img src="@/assets/img/home/aff1.png" alt="">
      </div>
    </div>
    <div class="top flex alcen" id="box2">
      <div class="top_list flex jucen">
        <img src="@/assets/img/home/aff7.png" alt="">
      </div>
      <div class="top_list sz40 font_bo">
        <div class="w100 center co6e">多维度洞悉联盟分销策略</div>
        <div class="w100 center ">对标佣金比例、EPC（百次点击转化金额）、Cookies追踪时长</div>
        <div class="w100 center ">大数据+AI算法获取联盟平台、渠道类型分布</div>
      </div>
    </div>
    <div class="top flex alcen" id="box3">
      <div class="top_list sz40 font_bo">
        <div class="w100 center">通过品牌匹配、搜索、国家地区/类型/平台筛选</div>
        <div class="w100 center ">快速触达<span class="co6e">20+大类、10万+联盟分销客</span></div>
        <div class="w100 center ">洞察<span class="co6e">分销带货数据</span></div>
      </div>
      <div class="top_list flex jucen">
        <img src="@/assets/img/home/aff2.png" alt="">
      </div>
    </div>
    <div class="top flex alcen" id="box4">
      <div class="top_list flex jucen">
        <img src="@/assets/img/home/aff6.png" alt="">
      </div>
      <div class="top_list sz40 font_bo">
        <div class="w100 center">发现渠道-筛选关注-邮箱建联-分组管理</div>
        <div class="w100 center co6e">高效闭环合作</div>
      </div>
    </div>
    <div class="top flex alcen" id="box5">
      <div class="top_list sz40 font_bo">
        <div class="w100 center">API自动化授权接入</div>
        <div class="w100 center co6e">在<span class="co6e">一个系统</span>管理<span class="co6e">多国家、多平台、多项目</span></div>
      </div>
      <div class="top_list">
        <img src="@/assets/img/home/aff5.png" alt="">
      </div>
    </div>
    <div class="top flex alcen" id="box6">
      <div class="top_list flex jucen">
        <img src="@/assets/img/home/aff3.png" alt="">
      </div>
      <div class="top_list sz40 font_bo">
        <div class="w100 center">洞悉分销经营情况</div>
        <div class="w100 center co6e"><span class="co6e">多维数据可视化看板</span>助力高效决策</div>
      </div>
    </div>
    <div class="top flex alcen" id="box7">
      <div class="top_list sz40 font_bo">
        <div class="w100 center">多维度透视分销订单明细</div>
        <div class="w100 center co6e"><span class="co6e">自动识别存疑订单</span>，规避佣金损失</div>
      </div>
      <div class="top_list">
        <img src="@/assets/img/home/aff4.png" alt="">
      </div>
    </div>
    <div class="top1" id="box8">
      <div class="w100 flex jucen sz30 font_bo top1_top">常见问题</div>
      <div class="w80 list">
        <el-collapse v-model="activeName">
          <el-collapse-item title="可以在手机登录使用吗？" name="1">
            <div>目前仅支持PC端使用、不支持多设备同时登陆；为了保障您的使用体验，切勿与他人分享。</div>
          </el-collapse-item>
          <el-collapse-item title="[行业洞察]和[竞品情报]的区别？" name="2">
            <div>​您可以在<span class="co00 font_bo">[行业洞察]</span>中，了解到您所选的垂直行业（分销领域中具有代表性的）标杆品牌的分销数据，以及该行业的分销渠道详情；<span class="co00 font_bo">[竞品情报]</span>中则可以看到您所选品牌、所选国家市场的联盟分销数据，并了解为该品牌分销的渠道详情。</div>
          </el-collapse-item>
          <el-collapse-item title="佣金比例、EPC 和 Cookies 具体指的是？" name="3">
            <div><span class="co00 font_bo">佣金比例</span>为所选品牌发布的联盟分销项目中，指定向分销渠道结算的比例（或金额），即，每成交一单后渠道所能赚取的“单价的百分比（或金额）”；<span class="co00 font_bo">​EPC</span> 为 Earnings Per 100 Clicks 百次点击所转化的销售佣金额，由 FOSHO 智能算法结合主流平台的数据测算得出，过去90天的平均预估值；<span class="co00 font_bo">Cookies</span> 的值为该联盟分销项目的追踪时长。数据为T+14动态更新的，可能会有滞后。</div>
          </el-collapse-item>
          <el-collapse-item title="联盟客类型的环形图是如何统计的？" name="4">
            <div>​该环形图对不同联盟分销渠道类型进行<span class="co00 font_bo">“渠道数量”</span>（非销量）占比统计，由 FOSHO 智能算法测算得出。单一联盟客归类为多个渠道类型时会被复算。</div>
          </el-collapse-item>
          <el-collapse-item title="为什么环形图里有显示的类型，在筛选后没有结果？" name="5">
            <div>​该环形图由 FOSHO 智能算法结合大数据测算得出，部分分类的渠道数据尚在处理，所以暂时没有显示在筛选结果中；我们的数据会持续更新，敬请期待。</div>
          </el-collapse-item>
          <el-collapse-item title="联盟客类型是如何定义的？" name="6">
            <div>​​我们的算法根据不同渠道的平台、内容属性、实际带货内容页面、分销推广素材等进行判定。</div>
          </el-collapse-item>
          <el-collapse-item title="联盟客详情中，渠道是如何排序的？" name="7">
            <div>​​我们根据渠道体量、活跃度、预估分销成效等指标综合评级，并与您、您所选的行业及品牌进行算法匹配后，呈现在您的排序结果中。</div>
          </el-collapse-item>
          <el-collapse-item title="某品牌展示的联盟平台与我了解到的不符，有缺失。" name="8">
            <div>​​FOSHO 算法会对不同国家的分销行为进行匹配区分，归入不同国家市场的数据，在该品牌的联盟分销数据指标框的左上方可以切换市场。目前大部分品牌数据仅上线了主要市场（美国）的数据，少部分品牌已经有不同国家市场数据支持切换，持续更新上线中。</div>
          </el-collapse-item>
          <el-collapse-item title="某品牌展示的联盟客与我了解到的不符，数量少。" name="9">
            <div>​​FOSHO AFF 主要收录过去一年的活跃渠道，并精准筛选出加入联盟分销的数据，筛选结果数量会和您的认知有偏差；平台内展现的数据需经过多层复杂处理筛选，并通过算法匹配后向您呈现，大量数据正在持续更新中，敬请期待。</div>
          </el-collapse-item>
          <el-collapse-item title="可选项中没有想要的品牌，如何获取？" name="10">
            <div>目前我们正陆续进行数据处理并上线，如有您希望洞察的其他品牌，欢迎与客服小F联系，我们的团队会加速处理，持续更新，敬请期待。</div>
          </el-collapse-item>
          <el-collapse-item title="无法给联盟分销渠道发送邮件？" name="11">
            <div>目前为早鸟免费测试账号，暂不开放邮箱建联功能，如有需求，可在后续上线的正式版本中使用。</div>
          </el-collapse-item>
          <el-collapse-item title="无法使用多平台管理功能？" name="12">
            <div>​目前为早鸟免费测试账号，暂不开放多平台管理功能，如有需求，可联系客服小F。</div>
          </el-collapse-item>
        </el-collapse>
        <p class="mb20 mt20">如遇到其他问题，欢迎扫描二维码，联系客服小F。</p>
        <p><img src="@/assets/img/home/kf2.png" alt=""></p>
      </div>
    </div>
    <!-- <icp></icp> -->
  </div>
</template>
<script>
import icp from '../icp/icp.vue'
export default {
  components:{
    icp
  },
  data() {
    return {
      scrollTop: '',
      PageId: '',
      gospa: true,
      activeName: '1',
      unm: 1,
      winHeight: null,
    }
  },
  created() {

  },
  mounted() {
    // window.addEventListener('scroll', this.handleScroll, true)
    // this.PageId = document.querySelector('#box2')
    // window.addEventListener('beforeunload', e => {
    //   window.scroll(0, 0)
    // })
    var that = this
    window.onscroll = function () {
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      //滚动条到底部的条件
      if (parseInt(Number(scrollTop)) + windowHeight == scrollHeight - 1) {
        //写后台加载数据的函数
        that.$nextTick(() => {
          that.gospa = false
        })
      } else {
        that.$nextTick(() => {
          that.gospa = true
        })
      }
    }
  },
  watch: {
    'winHeight': function (newVal, oldVal) {
      // if (newVal > 7000) {
      //   this.unm = 1
      // }
    },
  },
  methods: {
    handleScroll(e) {
      this.winHeight = e.target.scrollTop || document.documentElement.scrollTop
      if (this.unm == 1) {
        this.PageId = document.querySelector('#box2')
      } else if (this.unm == 2) {
        this.PageId = document.querySelector('#box3')
      } else if (this.unm == 3) {
        this.PageId = document.querySelector('#box4')
      } else if (this.unm == 4) {
        this.PageId = document.querySelector('#box5')
      } else if (this.unm == 5) {
        this.PageId = document.querySelector('#box6')
      } else if (this.unm == 6) {
        this.PageId = document.querySelector('#box7')
      } else if (this.unm == 7) {
        this.PageId = document.querySelector('#box8')
        // if (winHeight < 300) {
        //   this.$nextTick(() => {
        //     this.unm = 1
        //   })
        // }
      }

      // if (window.screenWidth = document.documentElement.clientWidth < 1600) {
      //   if (winHeight < 600) {
      //     this.PageId = document.querySelector('#box2')
      //   } else if (winHeight > 600 && winHeight < 1400) {
      //     this.$nextTick(() => {
      //       this.PageId = document.querySelector('#box3')
      //       this.gospa = true
      //     })
      //   } else if (winHeight > 1400 && winHeight < 2100) {
      //     this.$nextTick(() => {
      //       this.PageId = document.querySelector('#box4')
      //       this.gospa = true
      //     })
      //   } else if (winHeight > 2100 && winHeight < 2900) {
      //     this.$nextTick(() => {
      //       this.PageId = document.querySelector('#box5')
      //       this.gospa = true
      //     })
      //   } else if (winHeight > 2900 && winHeight < 3600) {
      //     this.$nextTick(() => {
      //       this.PageId = document.querySelector('#box6')
      //       this.gospa = true
      //     })
      //   } else if (winHeight > 3600 && winHeight < 4000) {
      //     this.$nextTick(() => {
      //       this.PageId = document.querySelector('#box7')
      //     })
      //   }
      //   else if (winHeight > 4000) {
      //     this.$nextTick(() => {
      //       this.gospa = false
      //     })
      //   }
      // } else {
      //   console.log('大屏');
      //   if (winHeight < 1200) {
      //     this.PageId = document.querySelector('#box2')
      //   } else if (winHeight > 1200 && winHeight < 2400) {
      //     this.$nextTick(() => {
      //       this.PageId = document.querySelector('#box3')
      //       this.gospa = true
      //     })
      //   } else if (winHeight > 2500 && winHeight < 3500) {
      //     this.$nextTick(() => {
      //       this.PageId = document.querySelector('#box4')
      //       this.gospa = true
      //     })
      //   } else if (winHeight > 3500 && winHeight < 5200) {
      //     this.$nextTick(() => {
      //       this.PageId = document.querySelector('#box5')
      //       this.gospa = true
      //     })
      //     console.log(this.PageId, 'this.PageId');
      //   } else if (winHeight > 5200 && winHeight < 6500) {
      //     this.$nextTick(() => {
      //       this.PageId = document.querySelector('#box6')
      //       this.gospa = true
      //     })
      //   } else if (winHeight > 6300 && winHeight < 7700) {
      //     this.$nextTick(() => {
      //       this.PageId = document.querySelector('#box7')
      //     })
      //   }
      //   else if (winHeight > 6400) {
      //     this.$nextTick(() => {
      //       this.gospa = false
      //     })
      //   }
      // }


    },

    gomd() {
      // this.unm++
      // if (this.unm == 8) {
      //   this.unm = 1
      //   this.gospa = false
      // } else {
      //   this.gospa = true
      // }
      // // document.getElementById("box2").scrollIntoView();
      // window.scrollTo({
      //   'top': this.PageId.offsetTop,
      //   'behavior': 'smooth'
      // })
    }
  }
}
</script>
<style lang="less" scoped>
.guide {
  height: 100%;
  .top {
    width: 100%;
    height: 100vh;
    background: #fafafd;
    .top_list {
      width: 50%;
      img {
        width: 90%;
      }
    }
  }
  .box {
    width: 40px;
    height: 40px;
    border: 2px solid #be3c6e;
    position: fixed;
    left: 50%;
    margin-left: -20px;
    bottom: 50px;
    // animation: bounce-up 1.5s linear infinite;
  }
  @keyframes bounce-up {
    25% {
      transform: translateY(10px);
    }
    50%,
    100% {
      transform: translateY(0);
    }
    75% {
      transform: translateY(-10px);
    }
  }
  .top1 {
    width: 100%;
    background: #fafafd;
    .top1_top {
      // margin-top: 100px;
    }
  }
  .list {
    margin: 0 auto;
    margin-bottom: 100px;
    padding-bottom: 100px;
    img {
      width: 200px;
    }
  }
}
</style>
<style lang="less">
.guide {
  // .el-collapse-item__header {
  //   height: 60px;
  //   padding-left: 20px;
  //   font-size: 18px;
  //   color: #000;
  // }
  // .el-collapse-item__content {
  //   padding-left: 20px;
  //   padding-bottom: 20px;
  //   font-size: 18px;
  //   color: #000;
  // }
  .el-collapse-item__header {
    font-weight: bold;
    font-size: 18px;
    background: none;
    height: 90px;
  }
  .el-collapse-item__wrap {
    background: none;
    font-size: 16px;
    color: #000;
  }
  .el-icon-arrow-right:before {
    content: "\e791";
  }
}
</style>